import React from "react";
import PropTypes from "prop-types";
import {observable} from "mobx";
import LocaleContext from "../contexts/LocaleContext";
import {useEnvValue} from "@morningtrain/react-helpers";

function LocaleService(props) {


    const [currentLocaleValue] = useEnvValue('app.locale', props.defaultLocale);

    const localeBox = observable.box(currentLocaleValue);

    React.useEffect(() => {
        if(currentLocaleValue !== localeBox.get()) {
            localeBox.set(currentLocaleValue);
        }
    }, [currentLocaleValue]);

    return (
        <LocaleContext.Provider value={localeBox}>
            <React.Fragment>
                {props.children}
            </React.Fragment>
        </LocaleContext.Provider>
    );

}

LocaleService.defaultProps = {
    defaultLocale: 'en',
};

LocaleService.propTypes = {
    defaultLocale: PropTypes.string,
};

export default LocaleService;
